// Admin User [user@example.com]
export const getUserDetailsFromAssetUserLabel = (
	userLabel?: string,
): {email?: string; name: string} | undefined => {
	if (!userLabel) {
		return undefined;
	}
	const emailMatch = userLabel.match(/\[([^\]]+)\]/);
	return {
		email: emailMatch ? emailMatch[1] : undefined,
		name: userLabel.replace(/\s*\[[^\]]+\]\s*/, '').trim(),
	};
};
